/**
 * Handles grid element scaling in animated grids
 * @param {Object} element - Block
 */
export const animatedGridHandler = (element) => {
  const boxes = element.querySelectorAll('.grid-elem');
  boxes.forEach(box => {
    box.addEventListener('mouseenter', (e) => {
      // Change: Get top of target (Mouse hover)
      const targetRect = e.target.getBoundingClientRect();

      boxes.forEach(bBox => {
        // Change: Get top of other elements
        const bBoxRect = bBox.getBoundingClientRect();

        if (!e.target.classList.contains('grid-elem--animated')) {
          e.target.classList.add('grid-elem--animated');
        }
        // Change: Add class if not assigned
        if (!e.target.classList.contains('grid-elem--animated-height')) {
          e.target.classList.add('grid-elem--animated-height');
        }

        if (bBox != e.target) {
          bBox.classList.remove('grid-elem--animated');

          // Change: If / else detects if the box has the same top as the target  
          if (targetRect.top === bBoxRect.top)
          {
            // Change: Add class if not assigned
            if (!bBox.classList.contains('grid-elem--animated-height')) {
                bBox.classList.add('grid-elem--animated-height');        
            }
          } else {
            // Change: Remove class if tops are different
            bBox.classList.remove('grid-elem--animated-height');
          }
        }
      })
    })
  });
}